import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import { UserProvider } from "./context/UserContext";
import { ThemeProvider } from "./context/ThemeContext";
import { ConfigProvider } from "./context/ConfigContext";
import { LinkedAccountsProvider } from "./context/LinkedAccountsContext";
import { SocketProvider } from "./context/SocketContext";
import { OnlineStatusProvider } from "./context/OnlineStatusContext";
import { AlertProvider } from "./context/AlertContext";
import ProtectedRoute from "./routes/ProtectedRoute";
import Layout from "./components/layout/Layout";
import HomePage from "./pages/Home/HomePage";
import SignIn from "./pages/Signin/SignIn";
import SignUp from "./pages/SignUp/SignUp";
import Profile from "./pages/Profile/Profile";
import Discover from "./pages/Discover/Discover";
import Settings from "./pages/Settings/Settings";
import AccountLink from "./pages/AccountLink/AccountLink";
import Notifications from "./pages/Notifications/NotificationsPage";
import Messages from "./pages/Messages/MessagesPage";
import GamePage from "./pages/Game/GamePage";
import FollowRequests from "./pages/FollowRequests/FollowRequests";
import PageNotFound from "./pages/PageNotFound/PageNotFound";
import VerifyEmailPage from "./pages/VerifyEmailPage/VerifyEmailPage";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import AvatarSelectionPage from './pages/AvatarSelection/AvatarSelectionPage'
import MatchmakingPage from "./pages/Matchmaking/MatchmakingPage";
import PostDetailPage from "./pages/PostDetail/PostDetailPage";
import Privacy from "./pages/Privacy/Privacy";
import Terms from "./pages/Terms/Terms";
import "@/styles/index.scss"; 

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [
          { path: "/", element: <HomePage /> },
          { path: "/profile", element: <Profile /> },
          { path: "/discover", element: <Discover /> },
          { path: "/matchmaking", element: <MatchmakingPage /> },
          { path: '/account-link', element: <AccountLink /> },
          { path: "/settings", element: <Settings /> },
          { path: "/follow-requests", element: <FollowRequests /> },
          { path: "/post", element: <Navigate to="/" replace /> },
          { path: "/post/:postId", element: <PostDetailPage /> },
          { path: "/notifications", element: <Notifications /> },
          { path: "/messages", element: <Messages /> },
          { path: "/game/:gameId", element: <GamePage /> },
          { path: "/avatar/selection", element: <AvatarSelectionPage /> },
        ],
      },
    ],
  },
  { path: "/signin", element: <SignIn /> },
  { path: "/signup", element: <SignUp /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
  { path: "/reset-password", element: <ResetPassword /> },
  { path: "/privacy", element: <Privacy /> },
  { path: "/terms", element: <Terms /> },
  { path: "*", element: <PageNotFound /> },
  { path: "/verify-email", element: <VerifyEmailPage />}
]);

function App() {
  return (
    <ConfigProvider>
      <ThemeProvider>
        <UserProvider>
          <LinkedAccountsProvider>
            <SocketProvider>
              <OnlineStatusProvider>
                <AlertProvider>
                  <RouterProvider router={router} />
                </AlertProvider>
              </OnlineStatusProvider>
            </SocketProvider>
          </LinkedAccountsProvider>
        </UserProvider>
      </ThemeProvider>
    </ConfigProvider>
  );
}

export default App;
